import { BookMarkedIcon, ClipboardCheckIcon, FlaskConicalIcon, FolderOpenIcon, LayersIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Banco de 150 Actividades y Desafíos de Meteorología',
    description:
      '150 propuestas listas para utilizar o adaptar en clases sobre fundamentos, atmósfera, humedad, nubes, presión, vientos, frentes, tormentas, observación, pronóstico, clima y desafíos integradores. Organizadas por nivel de dificultad.',
    benefit: 'Materiales ya pensados para el aula: ahorra horas en cada trimestre.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Kit Completo de Evaluación de Meteorología',
    description:
      'Evaluación diagnóstica, bancos de preguntas, evaluaciones temáticas e integradoras, casos de análisis meteorológico, criterios de corrección, rúbricas, listas de cotejo, autoevaluaciones, coevaluaciones, instrumentos de seguimiento y evaluación final integradora.',
    benefit: 'Nunca más construyas un examen desde cero bajo presión.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: '100 Casos Meteorológicos y Situaciones para Analizar en el Aula',
    description:
      '100 situaciones prácticas sobre atmósfera y estructura atmosférica, temperaturas, humedad y nubes, presión y vientos, frentes y sistemas meteorológicos, tormentas y fenómenos severos, observación e instrumentos, mapas sinópticos, pronósticos y variabilidad climática.',
    benefit: 'Tus alumnos aprenden analizando situaciones reales de meteorología.',
    value: 'USD 14',
    icon: LayersIcon,
  },
  {
    number: '04',
    title: 'Laboratorio de Meteorología: 50 Experimentos y Demostraciones',
    description:
      '50 experiencias y demostraciones para explorar de forma práctica radiación y energía, temperatura, humedad y condensación, nubes, presión, vientos, frentes, fenómenos atmosféricos, observaciones y actividades con instrumentos. Todas con materiales accesibles y procedimientos seguros.',
    benefit: 'Tus alumnos aprenden haciendo de forma segura.',
    value: 'USD 14',
    icon: FlaskConicalIcon,
  },
  {
    number: '05',
    title: '100 Secuencias Didácticas de Meteorología Listas para el Aula',
    description:
      '100 secuencias organizadas con lógica de inicio, desarrollo, aplicación, cierre y evidencia de aprendizaje: fundamentos, atmósfera, temperatura, humedad y nubes, presión y vientos, frentes, tormentas, observación, pronóstico, clima y variabilidad. Cada una lista para adaptarse a tu contexto.',
    benefit: 'Planificás cada clase en minutos, con una estructura pedagógica probada.',
    value: 'USD 14',
    icon: BookMarkedIcon,
    wide: true,
  },
];
